import { createClient } from '@supabase/supabase-js';

// Fallback values to prevent site crash
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://vphotvqpcyvwlbsrufyq.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZwaG90dnFwY3l2d2xic3J1ZnlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkzNDA0NzUsImV4cCI6MjA3NDkxNjQ3NX0.xTP4OA1z27FSPLHxbe5uhazSl2KSpCO2G4rFvfmWDoI';

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn('⚠️ Using fallback Supabase environment variables. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in Netlify environment variables.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});



